import { render, staticRenderFns } from "./SuggestionAlgorithmModal.vue?vue&type=template&id=15ee3ff3&scoped=true"
import script from "./SuggestionAlgorithmModal.vue?vue&type=script&lang=js"
export * from "./SuggestionAlgorithmModal.vue?vue&type=script&lang=js"
import style0 from "./SuggestionAlgorithmModal.vue?vue&type=style&index=0&id=15ee3ff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ee3ff3",
  null
  
)

export default component.exports